/**
 * @ngdoc service
 * @name permissionsService
 * @module flowingly.directives
 *
 * @description A service for checking user permissions
 */

import { Services } from '@Shared.Angular/@types/services';
import { FlowinglyPermissions } from '@Shared.Angular/flowingly.services/flowingly.constants';

class PermissionsService {
  static $inject = ['sessionService'];
  private sessionService: Services.SessionService;

  constructor(sessionService: Services.SessionService) {
    this.sessionService = sessionService;
  }

  checkEnvironment(
    allowedEnvironments: string[] | undefined,
    currentEnvironment: string
  ): boolean {
    if (allowedEnvironments === undefined) {
      return true;
    }
    return allowedEnvironments.indexOf(currentEnvironment) >= 0;
  }

  currentUserHasPermission(requiredPermission: FlowinglyPermissions): boolean {
    return this.currentUserHasPermissions([requiredPermission]);
  }

  currentUserHasPermissions(
    requiredPermissions: FlowinglyPermissions[]
  ): boolean {
    if (requiredPermissions === undefined || requiredPermissions.length === 0) {
      return false;
    }
    const userPermissions = this.sessionService.getPermissions();
    if (!userPermissions) return false;
    return requiredPermissions.every((permission) => {
      return userPermissions.indexOf(permission) >= 0;
    });
  }

  currentUserHasAnyOfPermissions(
    requiredPermissions: FlowinglyPermissions[]
  ): boolean {
    if (requiredPermissions === undefined || requiredPermissions.length === 0) {
      return false;
    }
    const userPermissions = this.sessionService.getPermissions();
    return requiredPermissions.some((permission) => {
      return userPermissions.indexOf(permission) >= 0;
    });
  }
}

angular
  .module('flowingly.directives')
  .service('permissionsService', PermissionsService);

export type PermissionsServiceType = PermissionsService;
